export default {
  SET_STUDY_PLAN: function(state, details) {
    state.details = details;
  },
  SET_STUDY_PLAN_PREVIEW: function(state, details) {
    state.details = details;
  },
};
